export default __webpack_public_path__ + "static/media/figma_logo.c1f87c70.svg";